import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoaurangabadcab() {



  const cardData =
  {
    keyword: 'Mumbai to Aurangabad Cab  ',
    heading: 'Shambhu Cabs: Mumbai to Aurangabad Cab  ',
    headingDescription: 'Shambhu Cabs offers dependable Mumbai to Aurangabad Cab services, ensuring a safe, comfortable, and worry-free travel experience for families, tourists, business travelers, and corporate groups. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers provides a smooth and relaxing journey from Mumbai to Aurangabad with well-maintained vehicles and professional chauffeurs. With flexible one-way and round-trip packages, 24/7 booking support, and doorstep pickup from South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs makes long-distance travel convenient and affordable. Whether you’re visiting Ajanta–Ellora Caves, Grishneshwar Temple, or heading for business meetings, Shambhu Cabs delivers reliable Mumbai to Aurangabad cab services with comfort, punctuality, and complete peace of mind.',

    top: 'Top Places to Visit in Aurangabad with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, a UNESCO World Heritage Site, are world-famous for their ancient Buddhist rock-cut architecture and breathtaking murals dating back to the 2nd century BCE. These caves depict the life of Buddha through exquisite paintings and sculptures, making them a masterpiece of ancient Indian art and spirituality."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, also a UNESCO World Heritage Site, showcase 34 magnificent rock-cut temples of Hindu, Buddhist, and Jain traditions. The renowned Kailasa Temple (Cave 16) is carved entirely from a single rock and is considered one of the greatest architectural marvels in the world."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Often called the 'Taj of the Deccan', Bibi Ka Maqbara was built by Aurangzeb’s son Azam Shah in memory of his mother. The structure resembles the Taj Mahal and features Mughal gardens, intricate carvings, and beautiful marblework, making it one of Aurangabad’s most iconic monuments."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort is a powerful hill fortress known for its extraordinary defensive design, steep climbs, and stunning views. Built in the 12th century, the fort is famous for the Chand Minar, dark passageways, and its strategic importance in medieval Deccan history."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki, meaning 'water mill', is an engineering marvel from the 17th century. It used a clever water channel system to power a mill that served pilgrims and residents. The serene complex includes a pond with floating fish and the tomb of Baba Shah Musafir."
  },
  {
    "title": "Aurangabad Caves",
    "description": "The Aurangabad Caves are a group of 12 Buddhist caves carved in the 6th and 7th centuries. Known for their detailed sculptures and artistic carvings, the caves offer a peaceful environment and panoramic views of the city from the hills."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Located near Ellora, this ancient temple is one of the 12 Jyotirlingas of Lord Shiva. The temple features beautiful Hemadpanthi architecture and a powerful spiritual atmosphere, attracting devotees from across India."
  },
  {
    "title": "Siddharth Garden & Zoo",
    "description": "A popular family attraction in Aurangabad, Siddharth Garden features lush lawns, landscaped gardens, and a well-maintained zoo. It is located close to Bibi Ka Maqbara and offers a refreshing nature experience for children and adults."
  },
  {
    "title": "Salim Ali Lake & Bird Sanctuary",
    "description": "Named after the famous ornithologist Dr. Salim Ali, this lake and bird sanctuary hosts diverse migratory and local bird species. The peaceful surroundings, walking paths, and scenic lake make it a perfect spot for nature lovers and photographers."
  },
  {
    "title": "Himayat Bagh",
    "description": "Himayat Bagh is a 17th-century Mughal-era garden that once served as an orchard and nursery. With its greenery, old water structures, and wide open spaces, it offers a calm retreat from the city's hustle."
  }
],


"services": [
  {
    "name": "Mumbai to Aurangabad Cab",
    "description": "Mumbai to Aurangabad Cab provides safe, reliable, and comfortable long-distance travel between Mumbai and Aurangabad. Ideal for business travelers, tourists visiting Ajanta-Ellora, and families, this service ensures timely pickups, professional drivers familiar with all major routes, and well-maintained vehicles. Passengers can enjoy a hassle-free journey with options for sedans, SUVs, and luxury cars, complete with door-to-door service and smooth highway travel."
  },
  {
    "name": "Aurangabad to Mumbai One Way Taxi",
    "description": "Aurangabad to Mumbai One Way Taxi is perfect for travelers needing a single-direction trip from Aurangabad to Mumbai. This service is ideal for airport transfers, corporate travel, or personal relocation. Vehicles are well-maintained, drivers are professional and courteous, and the service provides transparent pricing, ensuring a stress-free and convenient intercity journey."
  },
  {
    "name": "Aurangabad to Mumbai Taxi",
    "description": "Aurangabad to Mumbai Taxi offers reliable and comfortable long-distance travel for passengers traveling from Aurangabad to Mumbai. With professional chauffeurs, clean vehicles, and multiple vehicle options including sedans and SUVs, this service ensures a safe, timely, and enjoyable journey along highways connecting the two cities."
  },
  {
    "name": "One Way Cab Mumbai to Aurangabad",
    "description": "One Way Cab Mumbai to Aurangabad caters to passengers seeking single-direction travel without the need for a return. Perfect for airport transfers, business meetings, or leisure trips, this service offers affordable fares, professional drivers, and well-maintained vehicles for a smooth and convenient intercity experience."
  },
  {
    "name": "Mumbai to Aurangabad Taxi Fare",
    "description": "Mumbai to Aurangabad Taxi Fare service provides transparent and competitive pricing for travelers. It offers detailed fare estimates for one-way, round-trip, and multi-day rentals, helping passengers plan their budget effectively. With options for sedans, SUVs, and luxury vehicles, passengers can choose a vehicle that suits their comfort and budget requirements."
  },
  {
    "name": "Mumbai to Aurangabad Taxi",
    "description": "Mumbai to Aurangabad Taxi ensures comfortable, safe, and reliable travel between the two cities. Ideal for corporate trips, tourist visits, and family travel, this service includes professional chauffeurs, timely pickups, clean and well-maintained vehicles, and flexible booking options for one-way or round trips."
  },
  {
    "name": "Mumbai to Aurangabad One Way Taxi",
    "description": "Mumbai to Aurangabad One Way Taxi is designed for passengers requiring single-direction travel. This service is highly popular for airport transfers, business visits, and personal trips. With experienced drivers, sanitized vehicles, and easy online booking, passengers enjoy a smooth and convenient journey."
  },
  {
    "name": "Mumbai to Aurangabad Car Rental",
    "description": "Mumbai to Aurangabad Car Rental provides flexible and affordable options for travelers looking for self-driven or chauffeur-driven vehicles. Customers can choose from a wide range of cars including sedans, SUVs, and premium vehicles. The service ensures comfortable seating, highway-ready cars, and professional drivers for a stress-free intercity journey."
  },
  {
    "name": "Mumbai to Aurangabad Cab Booking",
    "description": "Mumbai to Aurangabad Cab Booking allows passengers to reserve their preferred vehicle online quickly and securely. This service offers multiple vehicle options, transparent pricing, and timely confirmation. Ideal for corporate travelers, tourists, and families, it ensures a seamless and convenient booking experience for a comfortable trip."
  },
  {
    "name": "Mumbai Aurangabad Taxi Service",
    "description": "Mumbai Aurangabad Taxi Service offers dependable, safe, and comfortable long-distance travel. Vehicles are well-maintained, chauffeurs are professional and trained for intercity highways, and booking options are flexible. Passengers enjoy timely pickups, door-to-door service, and a relaxing travel experience between Mumbai and Aurangabad."
  },
  {
    "name": "Mumbai Airport to Aurangabad Taxi",
    "description": "Mumbai Airport to Aurangabad Taxi provides convenient and reliable airport transfers for travelers heading to Aurangabad. With professional drivers, well-maintained vehicles, and timely pickups, this service ensures a stress-free journey. Ideal for tourists, business travelers, and families, it guarantees safety, comfort, and on-time arrivals."
  },
  {
    "name": "Mumbai to Sambhajinagar Cab",
    "description": "Mumbai to Sambhajinagar Cab service caters to travelers visiting Aurangabad’s Sambhajinagar region. With well-maintained vehicles, professional chauffeurs, and flexible booking options, passengers can enjoy a smooth and safe intercity ride. This service is suitable for corporate trips, leisure visits, and sightseeing tours."
  },
  {
    "name": "Navi Mumbai to Aurangabad Cab",
    "description": "Navi Mumbai to Aurangabad Cab offers comfortable and reliable intercity travel with multiple vehicle options. Passengers can choose from sedans, SUVs, and luxury cars, all driven by experienced chauffeurs. This service ensures timely pickups, highway comfort, and a safe and enjoyable journey between Navi Mumbai and Aurangabad."
  },
  {
    "name": "Thane to Aurangabad Cab",
    "description": "Thane to Aurangabad Cab provides a convenient and hassle-free option for travelers commuting between Thane and Aurangabad. Vehicles are maintained for long-distance comfort, chauffeurs are professional and knowledgeable, and the service ensures on-time pickups, safe travel, and smooth highway rides."
  },
  {
    "name": "Mumbai to Ajanta Ellora Tour Package",
    "description": "Mumbai to Ajanta Ellora Tour Package combines comfortable cab travel with a guided sightseeing experience. Passengers enjoy professional drivers, well-maintained vehicles, and flexible itineraries that cover Ajanta Caves, Ellora Caves, and nearby attractions. Ideal for families, tourists, and heritage travelers seeking a seamless intercity journey with sightseeing convenience."
  },
  {
    "name": "Mumbai to Paithan Cab Service",
    "description": "Mumbai to Paithan Cab Service offers reliable and comfortable travel to the historic town of Paithan near Aurangabad. The service includes professional chauffeurs, well-maintained vehicles, and flexible scheduling options, making it suitable for corporate trips, leisure visits, and cultural exploration."
  },
  {
    "name": "Mumbai to Aurangabad MIDC Cab",
    "description": "Mumbai to Aurangabad MIDC Cab caters to corporate travelers visiting the MIDC industrial area. Offering professional chauffeur-driven vehicles, timely pickups, and safe intercity travel, this service ensures convenience, comfort, and reliability for business visits and industrial site tours."
  }
],

"tableData": [
  ["Mumbai to Aurangabad Cab", "Aurangabad to Mumbai One Way Taxi"],
  ["Aurangabad to Mumbai Taxi", "One Way Cab Mumbai to Aurangabad"],
  ["Mumbai to Aurangabad Taxi Fare", "Mumbai to Aurangabad Taxi"],
  ["Mumbai to Aurangabad One Way Taxi", "Mumbai to Aurangabad Car Rental"],
  ["Mumbai to Aurangabad Cab Booking", "Mumbai Aurangabad Taxi Service"],
  ["Mumbai Airport to Aurangabad Taxi", "Mumbai to Sambhajinagar Cab"],
  ["Navi Mumbai to Aurangabad Cab", "Thane to Aurangabad Cab"],
  ["Mumbai to Ajanta Ellora Tour Package", "Mumbai to Paithan Cab Service"],
  ["Mumbai to Aurangabad MIDC Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Aurangabad Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides dependable Mumbai to Aurangabad cab services, ideal for heritage tours, business travel, family trips, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and well-maintained cabs that ensure a safe and comfortable journey to Aurangabad."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long-Distance Travel",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Aurangabad route, ensuring smooth, safe, and timely travel throughout the journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Aurangabad cab ride stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available 24/7 to assist you with bookings, travel queries, and route-related information."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customizable rental packages designed to suit your Mumbai to Aurangabad travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are regularly cleaned and sanitized before every trip, ensuring a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and smooth service, making your Mumbai to Aurangabad journey comfortable and hassle-free."
  }
]



















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Aurangabad cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Aurangabad cab services with professionally trained drivers.',
  },
  {
    question: 'How can I book a Mumbai to Aurangabad cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Mumbai.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Aurangabad cab bookings?',
    answer: 'Shambhu Cabs offers a variety of well-maintained sedans, SUVs, and luxury cars suitable for long-distance travel from Mumbai to Aurangabad.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Aurangabad route?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the Mumbai to Aurangabad highway routes to ensure a smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Aurangabad cab?',
    answer: 'Absolutely. You can choose your preferred pickup point in Mumbai and drop-off location anywhere in Aurangabad.',
  },
  {
    question: 'Is the Mumbai to Aurangabad cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Aurangabad cab booking services to match your travel needs.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai to Aurangabad cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene measures for passenger safety.',
  },
  {
    question: 'What payment options are available for Mumbai to Aurangabad cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Aurangabad journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Mumbai to Aurangabad travel for any assistance.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Shailesh Pawar',
    feedback: 'Our Mumbai to Aurangabad trip with Shambhu Cabs was extremely comfortable. The driver was punctual and courteous!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Nair',
    feedback: 'Highly reliable Mumbai to Aurangabad cab service. Clean car, smooth journey, and excellent support from Shambhu Cabs.',
    rating: 5,
  },
];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Aurangabad Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-aurangabad-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Aurangabad cab services with clean cars, trained drivers, and affordable taxi fares. Book one-way or round-trip cabs from Mumbai, Navi Mumbai, Thane, and Mumbai Airport to Aurangabad. Perfect for family travel, business trips, Aurangabad MIDC visits, Ajanta–Ellora tours, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-aurangabad-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Aurangabad Cab | One-Way & Round Trip Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Aurangabad cab with Shambhu Cabs. Affordable one-way and round-trip taxi service from Mumbai, Navi Mumbai, Thane, or Mumbai Airport to Aurangabad. Clean cars, expert drivers, and reliable outstation travel."
  />

  <meta
    name="keywords"
    content="Mumbai to aurangabad Cab, Aurangabad to mumbai one way taxi, Aurangabad to mumbai taxi, One way cab mumbai to aurangabad, Mumbai to aurangabad taxi fare, Mumbai to aurangabad taxi, Mumbai to aurangabad one way taxi, Mumbai to aurangabad car rental, Mumbai to aurangabad cab booking, Mumbai aurangabad taxi service, Mumbai airport to aurangabad taxi, mumbai to sambhajinagar cab, mumbai to aurangabad taxi fare, Mumbai to aurangabad taxi fare per day, navi mumbai to aurangabad cab, thane to aurangabad cab, mumbai to ajanta ellora tour package, mumbai to paithan cab service, mumbai to aurangabad MIDC"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoaurangabadcab;